import React from 'react';

import './Landing.css';

const LandingSection = () => (
  <div id="portfolio-landing">
    <div id="portfolio-landing-image" />
    <div id="portfolio-title">
      <h1>Produtos e Tecnologias</h1>
    </div>
  </div>
);

export default LandingSection;
